import React, { useEffect, useState } from 'react'
import { apiData } from '../../../actions';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

export default function SeeBeautiful() {
    const place = useSelector((state) => state.place);
    const localSelectedCity = localStorage.getItem("selectedCity");
    const formattedCity = place?.replace(/\b\w/g, (x) => x.toUpperCase()) || "";

    const [beautifulCity, setBeautifulCity] = useState("");
    const [beautifulCityAll, setBeautifulCityAll] = useState("");

    const [seeMoreModal, setSeeMoreModal] = useState(false);
    const [seeMoreLoading, setSeeMoreLoading] = useState(false);

    const Beautiful_city = async () => {
        const payload = { city: place };
        const apiRes = await apiData.getBeautifulCity(payload);

        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setBeautifulCity(apiRes.data.data);
        }
    };

    const Beautiful_city_All = async () => {
        const payload = { city: place };
        const apiRes = await apiData.ToursTravel(payload);

        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setBeautifulCityAll(apiRes.data.data);
        }
    };

    useEffect(() => {
        Beautiful_city();
        Beautiful_city_All();
    }, [place]);

    useEffect(() => {
        if (!beautifulCity) return; // waiting for API

        const container = document.getElementById("tour");
        if (!container) return;

        container.innerHTML = "";

        const scriptURL = beautifulCity.match(/src=["']([^"']+)["']/)?.[1];

        if (scriptURL) {
            const script = document.createElement("script");
            script.src = scriptURL;
            script.async = true;
            container.appendChild(script);
        } else {
            console.error("No script URL found in beautifulCity response");
        }

    }, [beautifulCity]);

    useEffect(() => {
        if (!seeMoreModal || !beautifulCityAll) return;

        const container = document.getElementById("beautifulCityAll");
        if (!container) return;

        container.innerHTML = "";
        setSeeMoreLoading(true);

        const scriptURL = beautifulCityAll.match(/src=["']([^"']+)["']/)?.[1];

        if (scriptURL) {
            const script = document.createElement("script");
            script.src = scriptURL;
            script.async = true;

            script.onload = () => setSeeMoreLoading(false);

            container.appendChild(script);
        } else {
            console.error("No script URL found");
            setSeeMoreLoading(false);
        }
    }, [seeMoreModal]); // run ONLY when modal opens

    const handleSeeAllClick = () => {
        setSeeMoreModal(true);
    };


    return (
        <section className="section-equal-padding bg-white top-spacing170 owl-nav-left">
            <div className="container-fluid">

                {/* Heading */}
                <div className="row">
                    <div className="col-12">
                        <div className="section-top-heading mb-3 mt-2 mb-md-5">
                            <h2 className="mb-2 text-black">
                                {localSelectedCity && localSelectedCity !== 'undefined'
                                    ? `See Beautiful ${formattedCity}`
                                    : 'See Beautiful'}
                            </h2>
                            <p>
                                Get set for an awesome vacation! Explore sightseeing tours, bus excursions,
                                exclusive passes, hidden gems — book your tours now!
                            </p>
                        </div>
                    </div>
                </div>

                {/* Widget container */}
                <div id="tour"></div>

                {/* View All Button */}
                <div className="d-flex justify-content-end">
                    <button className="view-all-btn" onClick={handleSeeAllClick}>
                        View All <i className="fa-solid fa-arrow-right"></i>
                    </button>
                </div>

            </div>

            {/* MODAL */}
            <Modal
                show={seeMoreModal}
                onHide={() => setSeeMoreModal(false)}
                size="xl"
                className='modal_xl see-pop'
            >
                <Modal.Header closeButton></Modal.Header>

                <Modal.Body id="beautifulCityAll">
                    {seeMoreLoading && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-3 text-secondary">Loading content...</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </section>
    );
}
